<template>
<div>
    <div>
        <vs-card noShadow ref="filterCard" :title="$t('salary_comparison')" color="blue" class="user-list-filters mb-8">
      <vs-row>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pr-1 mt-4">
            <label class="text-sm opacity-75 px-1">{{
                $t('client')
                }}</label>
             <v-select
                  v-model="selectClient"
                  :options="clients"
                  :reduce="(client) => client.ClientId"
                  class="w-full"
                  label="ShortName"
                  @input="onChange()"
              />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="pr-1 mt-4">
            <label class="text-sm opacity-75 px-1">{{
                $t('departament')|capitalize
                }}</label>
            <v-select
                  v-model="depto"
                  :options="positions"
                  class="w-full"
                  label="ShortName"
                  @input="onChange()"
              />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="pr-1 mt-4">
            <label class="text-sm opacity-75 px-1">
              {{$tc('type')|capitalize}}
              </label>
                <v-select
                    v-model="type"
                    :options="options"
                    class="w-full"
                    label="ShortName"
                    @input="onChange()"
                />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="pr-1 mt-4">
            <br>
            <vs-button  :disabled="list.length == 0" color="success" type="filled" class="w-full" @click="this.export">{{$t('export')}} </vs-button>
          </vs-col>
      </vs-row>
    </vs-card>
    <vs-card id="salary-analysis-loading" class="vs-con-loading__container">
     <salary-comparation-table 
        :data="list"
        />
    </vs-card>
    </div>
</div>
</template>

<script>
import vSelect from 'vue-select'
import client from '@/http/requests/client'
import salary_comparation from '@/http/requests/salary_comparation'
import loading from '@/mixins/Loading'
import SalaryComparationTable from './components/SalaryComparationTable.vue'
import {URL_CUSTOM_REPORT} from '@/urls.js'

export default {
  components: {
      vSelect,
      SalaryComparationTable
  },
  computed: {
   isLoading() {
      return this.loading.data
    },
  },
  data: () => ({
      list:[],
      type:"AVG",
      options:[
          "MIN",
          "AVG",
          "MAX",
      ],
      selectClient : "Select Option",
      depto : "Select Option",
      clients: [],
      deptos_ids : [],
      positions : [],
      params:{
          type:"AVG",
          depto:"NaN",
          client:null
      },
      loading: {
        data: true,
      },
  }),
  methods: {
    export() {
      let position = "NaN"
      if(this.depto !== 'Select Option' && this.depto !== null){
        let obj = this.deptos_ids.find(element => element.name === this.depto)
        position = obj.id
      }
      let request = `salary-analysis/0?client_id=${this.selectClient}&type=${this.type}&position=${position}`
      let new_url = URL_CUSTOM_REPORT + request
      if(this.selectClient !== 'Select Option' && this.selectClient !== null){
        window.open(new_url)
      }else{
        this.$vs.notify({
          color: 'warning',
          title: 'Alert',
          text: 'Seleccione Cliente Para Poder Exportar'
        })
      }
    },
    getOptions(){
      client.list().then((res) => {
        this.clients = res.data.clients
      })
      salary_comparation.getOptions(this.type).then((res)=>{
        this.deptos_ids = res.data
        res.data.forEach((option) => {
          this.positions.push(option.name)
        })
      })
      //this.getTableData(this.params)
    },
    onChange() {
        this.params.type = this.type
        this.params.depto = "NaN"
        if(this.depto !== 'Select Option' && this.depto !== null){
          let obj = this.deptos_ids.find(element => element.name === this.depto)
          this.params.depto = obj.id
        }
        this.params.client = null
        if(this.selectClient !== 'Select Option' && this.selectClient !== null){
          this.params.client = this.selectClient
        }
        
        if(this.selectClient !== 'Select Option' && this.selectClient !== null || this.depto !== 'Select Option' && this.depto !== null){
          this.getTableData(this.params)
        }else{
          this.$vs.notify({
             color: 'warning',
             title: 'Alert',
             text: 'Seleccione Cliente y Departamento'
           })
        }
    },
    getTableData(data){
      this.openLoading('salary-analysis-loading')
      this.loading.data = true
      salary_comparation.getTable(data).then((res)=>{
        this.list = res.data;
        this.closeLoading('salary-analysis-loading')
      })
      
    }
  },
  mounted() {
    this.getOptions()
  },
  mixins: [loading]
}
</script>

<style>
    .red-text{
        color: red;
    }
    .green-text{
        color: #17b3a3;
    }
</style>
